module.exports = __webpack_public_path__ + "1a9d01a5513b38cf97f46e1d9d5e15c2.svg";